import { useContext } from 'react';

import ModeChangeContext from '../../store/mode-change-context';
import ibm from '../../assets/IBM-logo.png';
import mastork from '../../assets/mastork.png';
import WorkCard from './WorkCard';
import styles from './PastWork.module.css'

const Experience = () => {

    const modeCtx = useContext(ModeChangeContext);

    const styleLight = {
        background: 'rgb(255,255,255)',
        color: '#000'
    }

    const styleDark = {
        background: 'rgb(14,19,31)',
        color: '#fff'
    }

    return (
        <div className={styles.section} id='experience' style={!modeCtx.mode ? styleLight : styleDark}>
            <div>
                <h1 className={styles.heading}>Experience</h1>
                <p className={styles.detail} style={{ fontWeight: !modeCtx.mode ? 'bold' : 'normal' }}>I don’t just build features. I build things that don’t break in production!</p>
            </div>
            <div className={styles.list}>
                <WorkCard src={ibm} alt={'IBM'} heading={'IBM'} duration={'July 2024 - Present'} position={'Application Developer'} detail1={'Delivered and optimized production-grade application features, improving system performance and enabling seamless integrations across services.'} detail2={'Led L2 production support for multiple lending applications, ensuring high availability, rapid incident resolution, and zero critical business disruption.'} />
                <WorkCard src={mastork} alt={'Mastork Tech.'} heading={'Mastork Tech.'} duration={'May 2023 - July 2023'} position={'Front-End Developer Intern'} detail1={'Built responsive and scalable user interfaces, turning design concepts into high-performance components and collaborating across teams to deliver seamless, production-ready user experiences.'} button link1={'https://spotlet.in'} btn1='Project Website' />
            </div>
        </div>
    );

};

export default Experience;
